export default __webpack_public_path__ + "static/media/benefits.4a3bb2b8.png";